import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CaixaGerenciarDetalharRoutingModule } from './caixa-gerenciar-detalhar-routing.module';
import { CaixaGerenciarDetalharComponent } from './caixa-gerenciar-detalhar.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { KnobModule } from 'primeng/knob';
import { MessagesModule } from 'primeng/messages';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import {AccordionModule} from 'primeng/accordion';
import { UtilPipeModule } from 'src/app/admihair/util-pipe/util-pipe.module';


@NgModule({
  declarations: [
    CaixaGerenciarDetalharComponent
  ],
  imports: [
    CommonModule,
    CaixaGerenciarDetalharRoutingModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    DividerModule,
    DropdownModule,
    ProgressSpinnerModule,
    KnobModule,
    MessagesModule,
    OverlayPanelModule,
    AccordionModule,
    UtilPipeModule
  ]
})
export class CaixaGerenciarDetalharModule { }
